import accountInfo from './account.info.vue'

export default accountInfo
